import React from "react";

import "../../RessourcesStyles/HorsCatalogue.css";

import HorsCatalogue from "./HorsCatalogue";
import HorsCatalogueManager from "./HorsCatalogueManager";
import HorsCatalogueRf from "./HorsCatalogueRf";

const ROLE_CONFIG = {
    APPRENANT: {
        title: "Demande hors catalogue",
        subtitle: "Renseignez les informations de la demande directement depuis cette page.",
        renderForm: (props) => <HorsCatalogue {...props} />,
    },
    MANAGER: {
        title: "Demande hors catalogue",
        subtitle: "Renseignez les informations de la demande pour vos collaborateurs.",
        renderForm: (props) => <HorsCatalogueManager {...props} />,
    },
    RF: {
        title: "Demande hors catalogue",
        subtitle: "Renseignez les informations de la demande pour les collaborateurs concernés.",
        renderForm: (props) => <HorsCatalogueRf {...props} />,
    },
};

export default function DemandeHorsCatalogueForm({
    campagneId,
    currentUserRole = "APPRENANT",
    hideCampagneSelect = false,
    onCancel,
    onSuccess,
    loading = false,
    embedded = false,
}) {
    const roleConfig = ROLE_CONFIG[currentUserRole] || ROLE_CONFIG.APPRENANT;

    return (
        <section className={`hc-page ${embedded ? "is-embedded" : ""}`}>
            <div className="hc-card">
                <div className="hc-header">
                    <h2 className="hc-title">{roleConfig.title}</h2>
                    <p className="hc-subtitle">{roleConfig.subtitle}</p>
                </div>

                {roleConfig.renderForm({
                    campagneId,
                    hideCampagneSelect,
                    onCancel,
                    onSuccess,
                    loading,
                })}
            </div>
        </section>
    );
}
